// extracted by mini-css-extract-plugin
module.exports = {"widgetBoxError":"_3mvqL_mUH2XQXSHl9J9Vpl","widgetBoxErrorOverlay":"_129FF8UaoZzUnRUYm0XznX","widgetBoxErrorMessage":"_3KdPdb2vyzxd10CPdDH6Cw"};